export const excelColor = "#007A33"
export const pdfColor = "#D32F2F"
export const primaryColor = "#0d6efd"